<template>
    <menu-left/>
</template>

<script>
    import MenuLeft from "_private/components/smart/layout/menuLeft";

    export default {
        components: {
            MenuLeft
        }
    };
</script>
